import * as React from 'react';
import { EditButton, Identifier, Labeled, NumberField, Record, RecordMap, TextField, UrlField } from 'react-admin';
import { Card, CardContent, CardHeader } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TranslateField } from '../components/TranslateField';

const useListStyles = makeStyles(theme => ({
	card: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		margin: '1.5rem 0',
		boxShadow: '0px 15px 20px #27313f0c !important',
		backgroundColor: 'white'
	},
	cardTitleContent: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	cardContent: theme.typography.body1,
	cardContentRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		margin: '0.5rem 0',
		fontWeight: 'bold'
	}
}));

interface TrainingMenuListProps {
	ids?: Identifier[];
	data?: RecordMap<Record>;
	basePath?: string;
}

export const TrainingMenuList = (props: TrainingMenuListProps) => {
	const { ids, data, basePath } = props;
	const classes = useListStyles();

	if (!ids || !data || !basePath) {
		return null;
	}

	return (
		<div style={{ margin: '1em', backgroundColor: '#F8F9FC' }} className="list-container">
			{ids.map(id => (
				<Card key={id} className={classes.card}>
					<CardHeader
						title={
							<div className={classes.cardTitleContent}>
                                <span>
                                    {data[id].name}
                                </span>
								<EditButton
									resource="training-menus"
									basePath={basePath}
									record={data[id]}
								/>
							</div>
						}
					/>
					<CardContent className={classes.cardContent}>
						<Labeled label="#" className={classes.cardContentRow}>
							<TextField record={data[id]} source="id" label="#"/>
						</Labeled>
						<Labeled label="NOTE" className={classes.cardContentRow}>
							<TextField record={data[id]} source="note" label="NOTE"/>
						</Labeled>
						<Labeled label="MENU_FILE" className={classes.cardContentRow}>
							<UrlField record={data[id]} source="menuUrl" label="MENU_FILE"/>
						</Labeled>
						<Labeled label="TYPE" className={classes.cardContentRow}>
							<TranslateField record={data[id]} source="type" label="TYPE"/>
						</Labeled>
						<Labeled label="FROM_BMR" className={classes.cardContentRow}>
							<NumberField record={data[id]} source="fromBMR" label="FROM_BMR"/>
						</Labeled>
						<Labeled label="TO_BMR" className={classes.cardContentRow}>
							<NumberField record={data[id]} source="toBMR" label="TO_BMR"/>
						</Labeled>
					</CardContent>
				</Card>
			))}
		</div>
	);
};
